import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { IFilterValueSelectorProps } from './interfaces';

export default function DropdownSelector({ filterValues, setFilterValues, options = [] }: IFilterValueSelectorProps) {
  const selectedOptions = options.filter((option) => filterValues.includes(option.value));

  return (
    <Autocomplete
      fullWidth
      multiple
      size="small"
      options={options}
      value={selectedOptions}
      getOptionLabel={(option) => option.label || 'N/A'}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={(_event, selectedOptions) => {
        const selectedValues = selectedOptions.map((option) => option.value);
        setFilterValues(selectedValues);
      }}
      slotProps={{
        chip: {
          size: 'small',
          sx: { height: 24, fontSize: '0.75rem', m: '2px' },
        },
      }}
      renderInput={(params) => <TextField {...params} size="small" />}
    />
  );
}
